<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Design System Components
	import {
		ControlsContainer,
		Scroll,
		Stack,
		Text,
		ListItem,
	} from '@Shelly/shelly-design-system/index';
	//Types
	import type { Device } from 'src/types/Device';
	//Stores
	import {
		createMemberStatusSnapshot,
		readDeviceStatus,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	//Helpers
	import { isSmokeLTE } from 'src/helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { navigateToDevice } from 'src/stores/ui/navigate-to';

	export let device: Device;

	const currentDeviceFireGroup: number = readDeviceStatus(device.id)?.device?.group || 0;

	$: smokeDeviceIds = Object.values($devices)
		.filter((d) => isSmokeLTE(d.type))
		.map((d) => d.id);
	$: memberStatusStore = createMemberStatusSnapshot(smokeDeviceIds);
	$: memberStatus = $memberStatusStore;

	$: devicesInSameFireGroup = Object.values($devices).reduce<Device[]>((filteredDevices, dev) => {
		if (isSmokeLTE(dev.type)) {
			const deviceFireGroup = memberStatus[dev.id]?.device?.group;
			if (deviceFireGroup !== undefined && deviceFireGroup === currentDeviceFireGroup) {
				filteredDevices.push(dev);
			}
		}
		return filteredDevices;
	}, []) as Device[];

	const getDeviceAvatar = (device: Device): string => {
		if (typeof device !== 'string') {
			if (device?.image) {
				return device.image;
			} else if (device?.icon) {
				return device.icon;
			} else if (device?.backgroundColor) {
				return device.backgroundColor;
			}
		}
		return 'fak fa-solid-shelly';
	};
</script>

<ControlsContainer smallerScroll class="mb-s" size="s">
	<svelte:fragment slot="first">
		<Text element="p" class="text-bold mb-s">
			{capFirstChar(
				$format('fire_group_heading', {
					default: `Fire Group: ${currentDeviceFireGroup}`,
					values: { fireGroup: currentDeviceFireGroup },
				}),
			)}
		</Text>
		<Scroll smallerScroll>
			<Stack gap="xs">
				{#each devicesInSameFireGroup as listItem}
					<ListItem
						icon={getDeviceAvatar(listItem)}
						title={typeof listItem !== 'string'
							? listItem?.name
							: $format('title_unknown_device', {
									default: 'Unknown Device',
								})}
						actionBtn
						on:click={() => {
							navigateToDevice(listItem.id);
						}}
						progress={{
							percent: 0,
							showPercentBar: false,
						}}
					/>
				{/each}
			</Stack>
		</Scroll>
	</svelte:fragment>
</ControlsContainer>
